/**
* Initializes a quantity selector dropdown with options from 1 up to the specified quantity,
* and applies the Select2 plugin with search disabled.
*
* @param {jQuery} qtySelector - The jQuery object representing the quantity dropdown element to initialize.
* @param {number} qty - The maximum quantity to display as selectable options.
*/
function initCustomBoxQty (qtySelector, qty) {
    const selectedVal = Number(qtySelector.val());

    qtySelector.empty();

    for (let i = 1; i <= qty; i += 1) {
        qtySelector.append(`<option ${selectedVal === i ? "selected" : ""}>${i}</option>`);
    }

    qtySelector.select2({
        minimumResultsForSearch: -1
    });
}

/**
* Converts a price string (with optional comma as decimal separator) to its value in cents.
* Removes all non-digit and non-comma characters, then parses euros and cents.
*
* @param {string} text - The price text to convert (e.g., "12,34 €" or "1.234,56").
* @returns {number} The price in cents as an integer.
*/
function priceTextToCents(text) {
    // remove everything except digits and comma
    const cleaned = text.replace(/[^\d,]/g, "").trim();

    // split into two parts
    const parts = cleaned.split(",");
    const euros = parseInt(parts[0], 10);
    const cents = parts[1] ? parseInt(parts[1].padEnd(2, "0").slice(0, 2), 10) : 0;

    return euros * 100 + cents;
}

/**
* Retrieves the closest ancestor element of the given child element that matches the ".js-custom-box" selector.
* @param {jQuery} childEl - The jQuery-wrapped DOM element whose parent is to be found.
* @returns {jQuery} - A jQuery object containing the matched parent elements with the ".js-custom-box" class.
*/
function getParentCustomBox(childEl) {
    return childEl.parents(".js-custom-box");
}

/**
* Retrieves concatenated product and UUID strings for all products within the same custom box as the triggered element.
*
* @param {jQuery} triggeredEl - The jQuery element that triggered the action, expected to be inside a custom box.
* @param {string} actionName - The action name used to construct the custom box URL data attribute.
* @returns {{pidString: string, uuidString: string} | null} An object containing comma-separated product IDs and UUIDs if a custom box is found, or null otherwise.
*/

function getCustomBoxIds(triggeredEl, isCartPage) {
    const $customBox = triggeredEl.parents(".js-custom-box");
    const $customBoxWrap = isCartPage ? $(".cart-page") : $(".minicart-popover");

    if ($customBox.length) {
        var sameCustomBoxId = $customBox.data("same-custom-box-id");
        var pidArray = [];
        var uuidArray = [];

        pidArray.push(triggeredEl.data("pid"));
        uuidArray.push(triggeredEl.data("uuid"));

        $customBoxWrap.find(".js-custom-box-product[data-same-custom-box-id='" + sameCustomBoxId + "'] .quantity").each(function () {
            var $customBoxProduct = $(this);

            pidArray.push($customBoxProduct.data("pid"));
            uuidArray.push($customBoxProduct.data("uuid"));
        });

        var pidString = pidArray.join(",");
        var uuidString = uuidArray.join(",");

        return {
            pidString: pidString,
            uuidString: uuidString
        };
    }

    return null;
}

/**
 * Generic function to update parent custom box price (normal or crossed).
 *
 * @param {jQuery} customBox - The custom box container.
 * @param {string} baseSelector - Selector for the base price (".js-product-price" or ".strike-through").
 * @param {string} outputClass - Class for the rendered price container.
 */
function updateCustomBoxPrice(customBox, baseSelector, outputClass) {
    const $productSummary = $(".js-product-summary");
    const currency = $productSummary.data("box-currency");
    const isLoyalty = $productSummary.data("is-loyalty");
    const sameCustomBoxId = customBox.data("same-custom-box-id");
    const $cartWrap = $(".cart-page");
    const isCartPage = $cartWrap.length;
    const $customBoxProducts = isCartPage ? $cartWrap.find(".js-custom-box-product[data-same-custom-box-id='" + sameCustomBoxId + "']") : $(".minicart-popover").find(".js-custom-box-product[data-same-custom-box-id='" + sameCustomBoxId + "']");

    let $basePriceEl = customBox.find(baseSelector);
    if (!$basePriceEl.length) return;

    // Remove previously inserted dynamic element
    customBox.find("." + outputClass).remove();

    // Convert base price to cents
    let totalCents = priceTextToCents($basePriceEl.text());
    $basePriceEl.addClass("d-none");

    // Add all child tiles
    $customBoxProducts.each(function () {
        const $tile = $(this);
        let $tilePrice = $tile.find(baseSelector).first();

        // If no loyalty price but loyalty is activated
        if ($tilePrice.length == 0 && baseSelector == ".js-crossed-price" && isLoyalty) {
            $tilePrice = $tile.find(".js-product-price").first();
        }

        if ($tilePrice.length) {
            totalCents += priceTextToCents($tilePrice.text());
        }
    });

    // Format final price
    const finalPrice =
        (totalCents / 100).toFixed(2).replace(".", ",") + " " + currency;

    // Insert dynamic element after base element
    $basePriceEl.after(
        `<div class="${outputClass} ${baseSelector === ".js-crossed-price" ? "strike-through" : ""}">
            ${finalPrice}
        </div>`
    );
}

/**
* Updates the displayed price and crossed-out price for a custom box in the cart UI.
*
* The `updatePrice` function updates the main product price element, while `updateCrossedPrice` updates the crossed-out (original) price element.
* Both functions utilize `updateCustomBoxPrice` to modify the relevant DOM elements based on the provided custom box data.
*
* @param {Object} customBox - The custom box object containing pricing information to be displayed.
*/
function updatePrice(customBox) {
    updateCustomBoxPrice(customBox, ".js-product-price", "custom-box-price");
}

/**
* Updates the crossed (original) price display for a custom box element.
* Calls the updateCustomBoxPrice utility to set the crossed price value in the DOM.
*
* @param {HTMLElement} customBox - The DOM element representing the custom box whose crossed price should be updated.
*/
function updateCrossedPrice(customBox) {
    updateCustomBoxPrice(customBox, ".js-crossed-price", "custom-box-crossed-price");
}

module.exports = {
    init: function () {
        $(".js-custom-box").each(function () {
            const $this = $(this);
            const sameCustomBoxId = $this.data("same-custom-box-id");
            const $qtySelector = $this.find(".quantity-select");
            let maxQtyArray = [];
            const customBoxQty = $qtySelector.val();

            updatePrice($this);
            updateCrossedPrice($this);

            maxQtyArray.push($this.data("max-quantity"));

            $(".js-custom-box-product[data-same-custom-box-id='" + sameCustomBoxId + "']").each(function () {
                const $customboxTile = $(this);
                const qty = $customboxTile.find(".quantity").val() / customBoxQty;
                const maxQty = $customboxTile.data("max-quantity") / qty;

                maxQtyArray.push(maxQty);
            });

            // Find smallest max quantity
            const smallestMaxQty = Math.min(...maxQtyArray);
            initCustomBoxQty($qtySelector, smallestMaxQty);
        });
    },
    getParentCustomBox: getParentCustomBox,
    getIds: getCustomBoxIds,
    updatePrice: updatePrice,
    updateCrossedPrice: updateCrossedPrice
};
